var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('v-expansion-panel-header',{attrs:{"color":"orange lighten-4"}},[_vm._v(" Cortes del Lote ")]),(!_vm.action)?_c('Tabla'):_c('Form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }